import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { MercuryCampaignAutoCompleteInput$, MercuryCampaignAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => (
   <span>
      {suggestion.text}
      {' '}
      {suggestion.id && `(${ suggestion.id })`}
   </span>
);
const MercuryCampaignIdAutoSuggest = renderAutoSuggestWithOptions(
   MercuryCampaignAutoCompleteObservable$,
   MercuryCampaignAutoCompleteInput$,
   renderSuggestion,
);

MercuryCampaignIdAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search campaigns name or input campaign id...',
};

export default MercuryCampaignIdAutoSuggest;
